import Navbar from "./Navbar";
import Footer from "./Footer";
import ConsentBanner from "../ConsentBanner";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--bg)] text-white">
      <Navbar />
      <main className="flex-1 pt-16">{children}</main>
      <Footer />
      <ConsentBanner />
    </div>
  );
}
